import _ from 'lodash'
import moment from 'moment'
import { defaultMapFilters } from './options'


const whitelabel = require('../../whitelabel.config')[process.env.VUE_APP_BRAND]

export default {
    data() {
        return {
            brand: whitelabel.brand,
        }
    },
    getJourneyById: (state) => (id) => state.results.find((item) => item.journey.id === id),
    allResultsRetrieved: (state) => (state.searchQuery ? state.searchQuery.results_retrieved <= state.results.length : false),
    filteredResultItems: (state) => {
        if (state.results.length) {
            if (whitelabel.enableMultipleJourneyTypeFilter) {
                return state.results.filter((result) => {
                    if (result.showPlaceholder) return true
                    return result.journey.depart.stages.some((i) => state.selectedMultipleResultStages.includes(i))
                })
            }
            if (state.resultFilter.selected !== 'all') {
                const filteredresults = _.filter(state.results, (item) => {
                    if (item.showPlaceholder) return true
                    return _.includes(item.journey.depart.stages, state.resultFilter.selected)
                })
                return filteredresults
            }
        }
        return state.results
    },
    sortedResultItems: (state, getters) => {
        if (getters.filteredResultItems.length) {
            if (state.resultSort.selected === 'travel-time') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.duration.value
                }])
            }

            if (state.resultSort.selected === 'arrival-time') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.arrival_at
                }])
            }

            if (state.resultSort.selected === 'wait-time') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    console.log(o.journey.depart.wait_time)
                    return o.journey.depart.wait_time
                }])
            }

            if (state.resultSort.selected === 'walk-distance') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.walking_distance.value
                }])
            }

            if (state.resultSort.selected === 'depature-time') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.departure_at
                }])
            }

            if (state.resultSort.selected === 'least-changes') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.stages.length
                }])
            }

            if (state.resultSort.selected === 'cost') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000

                    let costValue = o.journey.cost
                    if (_.toLower(costValue) === 'unknown') return 1000000
                    if (_.toLower(costValue) === 'free') return 0

                    costValue = costValue.replace(/\D/g, '')
                    if (costValue === '') {
                        return null
                    }
                    return _.parseInt(costValue)
                }])
            }

            if (state.resultSort.selected === 'emissions') {
                return _.sortBy(getters.filteredResultItems, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.carbon_emission
                }])
            }
        }

        return getters.filteredResultItems
    },
    resultFilters: (state, getters) => {
        const addedStages = []
        const filters = whitelabel.enableMultipleJourneyTypeFilter ? [] : [{
            icon: 'route',
            width: 20,
            stage: 'all',
            name: 'All',
        }]

        if (state.resultQueryStages.length) {
            state.resultQueryStages.forEach((stage) => {
                if (!addedStages.includes(stage)) {
                    const filter = {
                        name: _.capitalize(stage),
                        stage,
                        icon: getters.getSVGIconNameByTransportMode(stage),
                        selected: true,
                    }
                    filters.push(filter)
                    addedStages.push(stage)
                }
            })
        }

        getters.availableJourneyStages.forEach((stage) => {
            if (!addedStages.includes(stage)) {
                const filter = {
                    name: _.capitalize(stage),
                    stage,
                    icon: getters.getSVGIconNameByTransportMode(stage),
                    selected: state.selectedMultipleResultStages.includes(stage),
                }
                filters.push(filter)
                addedStages.push(stage)
            }
        })

        return filters.sort((a, b) => a.stage.localeCompare(b.stage))
    },
    getMapFilters: (state) => (journeyType) => {
        const filters = [...defaultMapFilters]
        if (state.currentJourney) {
            const toiletsCount = state.currentJourney[journeyType].destination_toilets.count
            if (toiletsCount) {
                filters.push({
                    name: 'Toilets',
                    count: toiletsCount,
                    icon: 'toilets',
                    slug: 'toilet',
                })
            }
        }
        return filters
    },
    getMapIconByTransportMode: (state) => (transportMode) => `/img/map/${whitelabel.brand}/${state.mapping.transportModes[transportMode]}.png`,
    getSVGIconNameByTransportMode: (state) => (transportMode) => (state.mapping.transportModes[transportMode] ? state.mapping.transportModes[transportMode] : transportMode),
    getIconNamesByStage: (state, getters) => (stage) => _.uniqBy(state.currentJourney[stage].stages.map((item) => getters.getSVGIconNameByTransportMode(item))),
    getIconsAndNamesByStage: (state, getters) => (journey, stage) => _.uniqBy(journey[stage].stages.map((item) => ({ icon: getters.getSVGIconNameByTransportMode(item), name: item })), 'name'),
    getSVGCircledIconNameByTransportMode: (state, getters) => (transportMode) => `${getters.getSVGIconNameByTransportMode(transportMode)}-c`,
    getAppointmentLength: (state) => (state.searchQuery ? moment(state.searchQuery.arrive_at_time, 'hh:mm').diff(moment(state.searchQuery.return_time, 'hh:mm'), 'minutes') : 60),
    campaignImpressionIds: (state) => state.campaignImpressions.map((impression) => impression.id),
    getUserLogged: (state) => {
        if (state.auth.token) {
            return true
        }
        return false
    },
    getCo2: (state) => {
        const carbon = []

        if (state.results.length) {
            for (let i = 0; i < state.results.length; i += 1) {
                const item = state.results[i]
                carbon.push(item.journey.carbon_emission)
            }
        }
        return _.sortBy(carbon)
    },
    availableJourneyStages: (state) => {
        const stages = state.results
            .filter((item) => !item.showPlaceholder && item.journey?.depart)
            .flatMap((item) => item.journey.depart.stages)
            .filter((stage) => !whitelabel.blockedTravelTypes.includes(stage));
        return [...new Set(stages)];
    },
}
